<script lang="ts" setup>
import moment from 'moment';
const { isMaintenance } = useStore();
</script>
<template>
    <section class="maintenance flex-col gap-5 flex items-center justify-center" >
        <img src="/images/maintenance.png" class="maintenance-img" alt="maintenance" />
        <div className='maintenance-text'>
            <h1>시스템 점검 중</h1>
            <p>
                현재 시스템 점검 중입니다. 양해 부탁드립니다. <br/>
                서비스 이용에 불편을 끼쳐드려 대단히 죄송합니다.<br/>
                
              <span v-if="isMaintenance.data">
                점검일시 
                {{moment(isMaintenance.data.from).format("M")}}월
                {{moment(isMaintenance.data.from).format("D")}}일
                {{moment(isMaintenance.data.from).format("hh:mm A")}} - 
                {{moment(isMaintenance.data.to).format("M")}}월
                {{moment(isMaintenance.data.to).format("D")}}일
                {{moment(isMaintenance.data.to).format("hh:mm A")}}
              </span>
            </p>
        </div>
    </section>
</template>